import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { LoginComponent } from '../Login/Login.component';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FooterService } from 'src/app/footer.service';

@Component({
  selector: 'main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent implements OnInit {
  isShowSignUp = true;
  showFooter = true;
  assetURL = environment.cloudFrontAssetURL;
  constructor(private ngbModel: NgbModal, public sharedService: SharedService, private dialog: MatDialog, private _router: Router, private footerService: FooterService,) {
    this.sharedService.loginMessageSubject.subscribe((data: any) => {
      if (data) {
        this.fillLoginData();
      }
    })
  }

  ngOnInit() { 
    this.footerService.showHeaderFooter$.subscribe(show => {
      this.showFooter = show;
    });
  }
  openDialog(isSellerLogin: boolean = false): void {
    const modelRef = this.ngbModel.open(LoginComponent, {
      size: 'lg',
      windowClass:'login-dialog'
    });
    modelRef.componentInstance.isFromSellerLogin = isSellerLogin;
    modelRef.result.then((data) => {
      if (isSellerLogin) {
        this._router.navigate(['affiliate']);
      }
    });
  }
  fillLoginData() {
    if (localStorage["userDetails"] != undefined && localStorage["userDetails"] != null && localStorage["userDetails"] != '') {
      this.isShowSignUp = false;
    }
  }
}

